// extracted by mini-css-extract-plugin
export var filtersBody = "filters__body_YLqzzJgzt6WtPB9NuID5";
export var filtersHeader = "filters__header_zv5vpoJZZ0OE3psca2Lr";